import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Common_MediaFragmentFragmentDoc } from './CommonMediaFragment.generated'
export type ContentFeatureMediaFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
}

export const ContentFeatureMediaFragmentFragmentDoc = gql`
  fragment ContentFeatureMediaFragment on Content {
    contentPolicyPolicyId
    featureMediaId
    featureMedia {
      ...Common_MediaFragment
    }
  }
  ${Common_MediaFragmentFragmentDoc}
`
